// UserByUserId.js
import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';
import UserByUserId from '../page/UserByUserId.jsx';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { USER_PROFILE_TABS } from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  { match, userId: userIdArg, listType: listTypeArg }
) => {
  const profileTabs = getRemoteConfigData(state, USER_PROFILE_TABS);
  const listType = listTypeArg || match?.params?.listType || profileTabs[0];
  const userId = userIdArg || match?.params?.userId;
  const meId = getMeData(state, 'id');
  return {
    meId,
    userId,
    listType,
    isMeProfile: meId && meId === userId,
  };
};

export default connect(mapStateToProps)(withRouter(UserByUserId));
